import type {WmlFile} from '@wix/document-services-types'

export interface XmlText {
    type: 'text'
    value: string
}

export interface XmlCData {
    type: 'cdata'
    value: string
}

export type XmlTag = string
export type XmlAttributeKey = string
export type XmlAttributeValue = string
export type XmlAttributes = Record<XmlAttributeKey, XmlAttributeValue>

export interface XmlElement {
    type: 'element'
    tag: XmlTag
    attributes: XmlAttributes
    children: XmlNode[]
}

export type XmlNode = XmlElement | XmlText | XmlCData
export type XmlAst = XmlElement
export type XmlFile = WmlFile<'xml'>

// Based on https://developer.mozilla.org/en-US/docs/Glossary/Entity#reserved_characters
export const XML_RESERVED_CHARS = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    '–': '&ndash;',
    '—': '&mdash;',
    '©': '&copy;',
    '®': '&reg;',
    '™': '&trade;',
    '≈': '&asymp;',
    '≠': '&ne;',
    '£': '&pound;',
    '€': '&euro;',
    '°': '&deg;'
}
